import { authApi } from './authApi';

export const uploadNegativeListFile = async (payload: any) => {
  return await authApi.post('admin/negative_list/upload-file/', payload);
};

export const fetchNegativeList = async (params = ''): Promise<any> => {
  return await authApi.get(`admin/negative_list/${params}`);
};

export const exportNegativeList = async (params = ''): Promise<any> => {
  return await authApi.get(`admin/negative_list/export/${params}`);
};

// negative list config
export const fetchNegativeListConfig = async (): Promise<any> => {
  return await authApi.get('admin/negative_list_config/');
};

export const negativeListConfigCreate = async (payload: any) => {
  return await authApi.post('admin/negative_list_config/', payload);
};

export const editNegativeListConfig = async (payload: any) => {
  return await authApi.patch(
    `admin/negative_list_config/${payload?.id}/`,
    payload?.body
  );
};

//Evaluation apis party master
export const startEvaluation = async (): Promise<any> => {
  return await authApi.get('admin/negative_list/evaluation/');
};

export const negativeScreeningStatus = async (): Promise<any> => {
  return await authApi.get('admin/negative_list/screening_status/');
};

export const partyNegativeListEvaluation = async (
  params = ''
): Promise<any> => {
  return await authApi.get(`admin/negative_list/evaluation/${params}/`);
};

export const negativeListEvaluationStatus = async (
  params = ''
): Promise<any> => {
  return await authApi.get(`admin/negative_list/evaluation-status/${params}/`);
};
